<template>
<div>
  <div>
    <div class="popupStyle-layout-1">
      <div class="title" style="margin-bottom: 16px;">
        <p>비교견적 받고</p>
        <p>최저가로 정비·수리하세요</p>
      </div>
      <div style="margin-bottom:300px;">
        <div class="alert-contents" style="margin-bottom: 16px;">
          <p>{{ text1 }}</p>
          <p>{{ text2 }}</p>
        </div>
      </div>
      <div>
        <router-link tag="div" :to="{ name:'RepairRequest', query: { customerId } }" class="siri-button">
          정비 견적받기
        </router-link>
        <router-link tag="div" :to="{ name:'RepairRequest2', query: { customerId } }" class="siri-button">
          수리 견적받기
        </router-link>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      text1: '고객님 주변의 정비·수리 업체를 찾아 견적문의를 대신해드립니다.',
      text2: '인슈넷FC 고객님께 무료로 제공되는 서비스입니다.',
      customerId: this.$store.state.customer.profile._id
    }
  },
  methods: {
    click () {
      history.back()
    }
  },
}
</script>

<style lang="scss">
.popupStyle-layout-1{
  height: 100vh;
  max-width:1000px;
  margin: 36px auto;
  @media screen and (max-width:$site-width){
    margin: 36px 20px;
  }
  .title {
    margin-bottom: 16px;
    font-family: NanumSquareOTF;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 32px;
    /* identical to box height, or 133% */

    letter-spacing: -0.56px;
    color: #000000;
  }
  .sub {
    font-family: NanumSquareOTF;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 24px;
    /* or 160% */

    letter-spacing: -0.3px;

    color: #666568;
  }
  .title-sub {
    font-family: NanumSquareOTF;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 21px;
    /* identical to box height, or 150% */
    
    letter-spacing: -0.28px;

    color: #666666;
  }
  .title-sub2 {
    margin-bottom: 8px;
    font-family: NanumSquareOTF;
    font-style: normal;
    font-weight: 800;
    font-size: 16px;
    line-height: 26px;
    letter-spacing: -0.32px;
    b {
      color: #174BE6;
    }
  }
  .alert-table-title {
    font-family: NanumSquareOTF;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 24px;
    letter-spacing: -0.3px;
    color: #999999;

    border-bottom: 2px solid #E8E8E8;
    display: flex;
    text-align: center;
    flex-direction: row;
    .column1 {
      width: 40%;
    }
    .column2 {
      width: 35%;
    }
    .column3 {
      width: 30%;
    }
  }
  .alert-table-value {
    font-family: NanumSquareOTF;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 24px;
    letter-spacing: -0.3px;
    color: #000000;

    border-bottom: 1px solid #E8E8E8;
    padding: 4px 0px;
    display: flex;
    text-align: center;
    flex-direction: row;
    .column1 {
      width: 40%;
    }
    .column2 {
      width: 35%;
    }
    .column3 {
      width: 30%;
    }
  }
  .table-more {
    font-family: NanumSquareOTF;
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 24px;
    letter-spacing: -0.3px;
    color: #000000;

    cursor: pointer;
    height: 36px;
    margin-top: 4px;
    border: 1px solid #E8E8E8;
    box-sizing: border-box;

    display: flex;
    justify-content: center;
    align-items: center;
  }
  .alert-contents {
    font-family: NanumSquareOTF;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 24px;
    letter-spacing: -0.3px;

    color: #666568;
    .contents-address {
      color: #000000;
    }
    b {
      font-weight: 700;
    }
  }
  .alert-change-contents {
    font-family: NanumSquareOTF;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 21px;
    letter-spacing: -0.28px;

    color: #666666;
  }
  .alert-contents-colorbox {
    font-family: NanumSquareOTF;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 24px;
    letter-spacing: -0.3px;

    color: #666568;
    background: #F3F6FF;
    padding: 12px 10px;
  }
  .input-box {
    padding: 13px 16px 11px 16px;
    border: 1px solid #D9D9D9;
    box-sizing: border-box;
    border-radius: 2px;

    font-family: NanumSquareOTF;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 24px;
    letter-spacing: -0.3px;

    color: #000000;
  }
  .address-box {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: NanumSquareOTF;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 24px;
    letter-spacing: -0.3px;
    color: #174BE6;
    height: 48px;
    border: 1px solid #174BE6;
    box-sizing: border-box;
  }
  .address-box-black {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: NanumSquareOTF;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 24px;
    letter-spacing: -0.3px;
    color: #000000;
    height: 48px;
    border: 1px solid #000000;
    box-sizing: border-box;
  }
  .account {
    font-family: NanumSquareOTF;
    font-size: 15px;
    line-height: 24px;
    letter-spacing: -0.3px;
    color: #999999;
    padding: 16px;
    height: 48px;
    border: 1px solid #D9D9D9;
    box-sizing: border-box;
    border-radius: 2px;
  }
  .contents-box {
    font-family: NanumSquareOTF;
    font-size: 15px;
    line-height: 24px;
    letter-spacing: -0.3px;
    color: #999999;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 7px;
    .el-select {
      color: #999999 !important;
      width: 49%;
      height: 48px !important;
      .el-input__inner {
        height: 48px !important;
        border-radius: 2px;
        border: 1px solid #D9D9D9;
        color: #999999 !important;
      }
    }
    /* .select {
      padding: 13px 16px 11px 16px;
      height: 48px;
      width: 49%;
      border: 1px solid #D9D9D9;
      box-sizing: border-box;
      border-radius: 2px;
      color: #999999;
    } */
    .input {
      padding: 13px 16px 11px 16px;
      height: 48px;
      width: 49%;
      border: 1px solid #D9D9D9;
      box-sizing: border-box;
      border-radius: 2px;
    }
  }
  .card {
    padding: 12px;
    border: 1px solid #D9D9D9;
    border-bottom: 0px;
    box-sizing: border-box;
    height: 72px;

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .title {
      margin-top: 15px;
      width: 50%;
      font-weight: bold;
      font-size: 18px;
      @media (min-width: 320px) and (max-width: 360px) {
        font-size: 14px;
      }
      line-height: 24px;
      /* identical to box height, or 143% */

      display: flex;
      flex-direction: column;
      letter-spacing: -0.3px;

      color: #000000;
    }
    .name {
      font-family: NanumSquareOTF;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      /* identical to box height, or 143% */

      display: flex;
      align-items: center;
      letter-spacing: -0.3px;

      color: #656565;
    }
    .button {
      cursor: pointer;
      width: 139px;
      height: 40px;
      font-weight: normal;
      font-size: 16px;
      line-height: 24px;
      /* identical to box height, or 150% */

      display: flex;
      text-align: center;
      align-items: center;
      justify-content: center;

      color: #FFFFFF;
              
      background: #174BE6;
      border-radius: 8px;
    }
    .button3 {
      font-family: NanumSquareOTF;
      font-style: normal;
      font-weight: bold;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: -0.3px;
      cursor: pointer;
      background: #C94D4D;
      border-radius: 8px;
      padding: 8px 10px 8px 10px;
      color: #FFFFFF;
      font-weight: normal;
    }
    .button2 {
      font-family: NanumSquareOTF;
      font-style: normal;
      font-weight: bold;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: -0.3px;
      border-radius: 8px;
      padding: 8px 10px 8px 10px;
      color: #C94D4D;
    }
  }
  .border-line {
    border-top: 1px solid #D9D9D9;
  }
  .footer-box {
    cursor: pointer;
    display: flex;
    align-items: center;

    font-family: NanumSquareOTF;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 21px;
    letter-spacing: -0.28px;
    color: #666666;
  }
}
.siri-button {
  cursor: pointer;
  width: 100%;
  height: 55px;
  margin-bottom: 10px;
  background: #174BE6;
  font-family: NanumSquareOTF;
  font-style: normal;
  font-weight: 800;
  font-size: 18px;
  line-height: 25px;
  /* identical to box height, or 175% */

  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  letter-spacing: -0.162025px;

  color: #FFFFFF;
}
</style>